import { ApiResponse } from '@creator/sdk/creator-sdk';
import creatorSdk from '@src/services/creator-sdk';
import { post as postApi } from '@creator/sdk/network/api-service';
import { setPost } from './posts';
import { Post } from '@creator/sdk/modules/upvote/upvote.model';
import reduxStore from '@src/store';

export type ManageDraftPostAction = 'draft' | 'reschedule' | 'publishNow';
export interface ManageDraftPostApiRequestPayload {
    userId: string;
    tokenName: string;
    postId: string;
    action: ManageDraftPostAction;
    scheduledAt?: string; // only for reschedule
}

export const manageDraftPost = async (payload: ManageDraftPostApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<Post>>('/post/draft', payload, {
        Authorization: `Bearer ${authIdToken}`,
        'X-Firebase-AppCheck': '',
    }, false);

    const post = data.payload;
    // sync updated post into Jotai
    setPost(post);
    // for Redux back‑compat
    reduxStore.getActions().upvote.setPost(post);

    return post;
};


// Validation for scheduledAt, date must be in the future and within one month from now
export const isScheduledAtValid = (scheduledAt: string) => {
    const scheduledDate = new Date(scheduledAt);
    const now = new Date();
    const oneMonthLater = new Date();
    oneMonthLater.setMonth(now.getMonth() + 1);

    // Check if valid date object, if it's after now, and before one month from now
    return !isNaN(scheduledDate.getTime()) && scheduledDate > now && scheduledDate < oneMonthLater;
};
